/**
 *
 * Asynchronously loads the component for ParentSummary
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const ParentSummary = lazyLoad(
  () => import('./index'),
  module => module.ParentSummary,
);
